import React, { useEffect, useState } from 'react';

const VersionChecker: React.FC<{ intervalMs?: number }> = ({ intervalMs = 5 * 60 * 1000 }) => {
  const [showUpdate, setShowUpdate] = useState(false);

  useEffect(() => {
    let currentHash = '';

    const checkVersion = async () => {
      try {
        const res = await fetch('/', { cache: 'no-cache' });
        const html = await res.text();
        const match = html.match(/\/static\/js\/main\.([a-f0-9]+)\.js/);
        const newHash = match ? match[1] : '';

        if (!currentHash) {
          currentHash = newHash;
        } else if (newHash && newHash !== currentHash) {
          setShowUpdate(true);
          // Auto-reload after 4 seconds
          setTimeout(() => window.location.reload(), 4000);
        }
      } catch (e) {
        // Ignore network errors
      }
    };

    checkVersion();
    const interval = setInterval(checkVersion, intervalMs);
    return () => clearInterval(interval);
  }, [intervalMs]);

  if (!showUpdate) return null;

  return (
    <div style={{
      position: 'fixed',
      bottom: '1.5rem',
      left: '50%',
      transform: 'translateX(-50%)',
      zIndex: 9999,
      background: 'white',
      borderRadius: '12px',
      boxShadow: '0 4px 24px rgba(0,0,0,0.15)',
      padding: '0.75rem 1.5rem',
      display: 'flex',
      alignItems: 'center',
      gap: '0.75rem',
      fontSize: '0.9rem',
      color: '#333',
      border: '1px solid #e9ecef',
      animation: 'fadeInUp 0.3s ease',
    }}>
      <div className="spinner-border spinner-border-sm text-danger" role="status">
        <span className="visually-hidden">Loading...</span>
      </div>
      <span>Mise à jour disponible, rechargement en cours...</span>
      <style>{`
        @keyframes fadeInUp {
          from { opacity: 0; transform: translate(-50%, 10px); }
          to { opacity: 1; transform: translate(-50%, 0); }
        }
      `}</style>
    </div>
  );
};

export default VersionChecker;
